import PropTypes from 'prop-types';
import {useState} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import Login from '../pages/auth/LoginPage';
import OperatorLogin from '../pages/auth/OperatorLoginPage';
import {useAuthContext} from './useAuthContext';
import {getSessionOperator} from "../helper/session";
import LoadingScreen from "../components/loading-screen";

// ----------------------------------------------------------------------

const AuthStatus = {
    AUTHENTICATED: 'AUTHENTICATED',
    NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
    AUTHENTICATED_AS_OPERATOR: 'AUTHENTICATED_AS_OPERATOR',
};

AuthGuard.propTypes = {
    children: PropTypes.node,
};

export default function AuthGuard({ children }) {
    const isAuthenticatedAsOperator = getSessionOperator();
    const { isAuthenticated, isInitialized } = useAuthContext();
    const { pathname } = useLocation();
    const [requestedLocation, setRequestedLocation] = useState(null);

    if (!isInitialized) {
        return <LoadingScreen />;
    }

    const determineAuthStatus = () => {
        if (!isAuthenticated) {
            return AuthStatus.NOT_AUTHENTICATED;
        }
        if (!isAuthenticatedAsOperator) {
            return AuthStatus.AUTHENTICATED_AS_OPERATOR;
        }
        return AuthStatus.AUTHENTICATED;
    };

    const authStatus = determineAuthStatus();

    if (authStatus === AuthStatus.NOT_AUTHENTICATED) {
        if (pathname !== requestedLocation) {
            setRequestedLocation(pathname);
        }
        return <Login />;
    }

    if (authStatus === AuthStatus.AUTHENTICATED_AS_OPERATOR) {
        if (pathname !== requestedLocation) {
            setRequestedLocation(pathname);
        }
        return <OperatorLogin />;
    }

    // TODO SREDITI
    if (requestedLocation && pathname !== requestedLocation) {
        setRequestedLocation(null);
        return <Navigate to={requestedLocation} />;
    }

    return <>{children}</>;
}
